import list from './list';
import create from './create';
import update from './update';
import show from './show'
import del from './delete';
import documentList from './document-list';
import factoredInvoice from './factored-invoice-list';

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show,
    del,
    documentList,
    factoredInvoice
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/debtor/index.js